import 'consumerweb-shim';
import 'core-js/stable'; // If imports from pp-react are required, please test this component on IE
import 'regenerator-runtime/runtime';
import React, { useEffect, useContext } from 'react';
import ReactDOM from 'react-dom';
import * as AppActions from '../../actions/AppActions';
import { hideSpinnerOverlay } from '../../utility/helper';
import Footer from '../../components/footer/footer';
import '../../../css/ppvx-app.less';
import '../../../css/ppvx.less';
import withTheme from '../../components/withTheme';
import FullPageError from './FullPageError';
import { Message } from '@paypalcorp/worldready-react';
import withWorldReady from '../../components/withWorldReady';
import { MessageFormat } from '@paypalcorp/worldready';
import { Context as WorldReadyContext } from '@paypalcorp/worldready-react';
function LandingErrorPage() {
  const worldReady = useContext(WorldReadyContext);
  const isGiftaid = window.location.href.includes('giftaid');
  useEffect(() => {
    AppActions.updateCurrentPage({ currentPage: 'landingError' });
    hideSpinnerOverlay();
  }, []);
  const handleReturn = () => {
    window.location.pathname = new MessageFormat(worldReady, {
      id: 'errors.landingerror.link.paypal',
    }).format();
  };

  return (
    <>
      <FullPageError
        title={<Message id="errors.landingerror.error.sessionexpired" />}
        body={
          isGiftaid ? (
            <Message id="errors.landingerror.error.startnewsessiongeneric" />
          ) : (
            <Message id="errors.landingerror.error.startnewsession" />
          )
        }
        linkLabel={<Message id="errors.landingerror.label.paypal" />}
        handleLinkClick={handleReturn}
        showCloseButton={true}
      />
      <Footer />
    </>
  );
}

const LandingErrorWithTheme = withWorldReady(withTheme(LandingErrorPage));

ReactDOM.render(
  <LandingErrorWithTheme />,
  document.getElementById('donateWrapper')
);
